export const Spinner = ({ className = "h-6 w-6" }: { className?: string }) => (
  <span
    role="status"
    aria-label="Завантаження"
    className={`inline-block animate-spin rounded-full border-2 border-current border-t-transparent ${className}`}
  />
);

export const Loader = ({ label = "Завантаження…" }: { label?: string }) => (
  <div className="flex flex-1 min-h-screen pb-4 flex-col items-center justify-center gap-4 bg-night">
    <Spinner className="h-8 w-8 text-brand" />
    <p className="text-sm text-neutral-400">{label}</p>
  </div>
);
